"use client";
import * as React from "react";
const SvgRefreshOutlined = ({
  title,
  titleId,
  ...props
}) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 16 16", "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M13.65 2.35A8 8 0 0 0 8 0a7.99 7.99 0 1 0 7.73 10h-2.08A6 6 0 0 1 8 14 6 6 0 0 1 8 2c1.66 0 3.14.69 4.22 1.78L8.99 7h7V0z" }));
export {
  SvgRefreshOutlined as default
};
